import React from 'react';
import { useCountryLabel } from 'hooks/useCountryLabel';
import { BaseCard } from './BaseCard';
import { TypesOfReturnsCardProps } from './CardProps';
import { HorizontalBar } from '../HorizontalBar';

export const TypesOfReturnsCard: React.FC<TypesOfReturnsCardProps> = ({
  cardId,
  returnTypeCounts,
  maxReturnTypeValue,
  handleReturnTypeClick,
  getReturnsByType,
  createSubmission,
}) => {
  const { localizeReturnLabel } = useCountryLabel();

  return (
    <BaseCard cardId={cardId}>
      {Object.entries(returnTypeCounts)
        .filter(([, count]) => count > 0)
        .sort(([, a], [, b]) => b - a)
        .map(([typeName, count]) => (
          <HorizontalBar
            key={typeName}
            label={localizeReturnLabel(typeName)}
            value={count}
            maxValue={maxReturnTypeValue}
            onClick={() => handleReturnTypeClick(typeName)}
            returns={getReturnsByType(typeName)}
            createSubmission={createSubmission}
          />
        ))}
    </BaseCard>
  );
};
